import {
  Box,
  Container,
  Flex,
  Grid,
  GridItem,
  HStack,
  Spacer,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import { IDashboard } from "../../models/admin/user.model";
import AdminHelpers from "../../services/admin/admin.service";
import Adminroutes from "./routes";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [dashboard, setDashboard] = useState<IDashboard>();
  const [data, setData] = useState<any[]>();
  useEffect(() => {
    AdminHelpers.getAdminDashboard()
      .then((response) => {
        const data: any[] = [];
        const keys = Object.keys(response.data.trainees_onboarded);
        keys.forEach((key, index) => {
          const obj: any = {
            name: key,
            trainees: response.data.trainees_onboarded[key],
          };
          data.push(obj);
        });
        setData(data);
        setDashboard(response.data);
      })
      .catch((err) => err);
  }, []);

  return (
    <>
      <Flex
        minHeight={"100vh"}
        height={"auto"}
        boxSizing="border-box"
        maxWidth={"100hw"}
      >
        <Box
          width={["4rem", "4rem", "4rem", "20%"]}
          position="relative"
          top="0"
          left="0"
          zIndex="100"
        >
          <AdminSidebar />
        </Box>
        <Box width={"100%"}>
          <AdminDashboardHeader />
          <Box
            pt="30px"
            px={["20px", "30px"]}
            width={"100%"}
            bg="#F9F8F8"
            height={"auto"}
            minHeight={"95vh"}
          >
            <Flex
              justifyContent="space-between"
              alignItems="flex-start"
              flexDirection={"column"}
              //   width={"auto"}
              gap="2rem"
              width="100%"
            >
              <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                Dashboard
              </Box>

              <Box
                width={"100%"}
                overflowX={"scroll"}
                className="scroll-hidden"
              >
               
                <Grid
                  templateColumns="repeat(4, 1fr)"
                  gap={6}
                  pb="20px"
                  mb="20px"
                  width="100%"
                >
                  <GridItem minWidth="250px">
                    <Container
                      bg="white"
                      borderRadius="10px"
                      px={10}
                      py={8}
                      boxShadow="base"
                      m={0}
                    >
                      <VStack pb={3} pt={1} align="center">
                        <Text color="#959595" fontSize={13}>
                          Total Course Sales
                        </Text>
                        <Text
                          color="#353535"
                          fontWeight="semibold"
                          fontSize={30}
                        >
                          <NumericFormat
                            value={dashboard?.total_revenue}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"₦"}
                          />
                        </Text>
                      </VStack>
                    </Container>
                  </GridItem>

                  <GridItem minWidth="250px">
                    <Container
                      bg="white"
                      borderRadius="10px"
                      px={10}
                      py={8}
                      boxShadow="base"
                      m={0}
                    >
                      <VStack
                        pb={3}
                        pt={1}
                        align="center"
                        onClick={() => {
                          navigate(Adminroutes.Trainer);
                        }}
                      >
                        <Text color="#959595" fontSize="14px">
                          Total Trainers
                        </Text>
                        <Text
                          color="#353535"
                          fontWeight="semibold"
                          fontSize={30}
                        >
                          {dashboard?.total_trainers}
                        </Text>
                      </VStack>
                    </Container>
                  </GridItem>

                  <GridItem minWidth="250px">
                    <Container
                      px={10}
                      py={8}
                      borderRadius="10px"
                      boxShadow="base"
                      bg="white"
                      m={0}
                    >
                      <VStack
                        pb={3}
                        pt={1}
                        align="center"
                        onClick={() => {
                          navigate(Adminroutes.Trainees);
                        }}
                      >
                        <Text color="#959595" fontSize="14px">
                          Total Trainees
                        </Text>
                        <Text
                          color="#353535"
                          fontWeight="semibold"
                          fontSize={30}
                        >
                          {dashboard?.total_trainees}
                        </Text>
                      </VStack>
                    </Container>
                  </GridItem>

                  <GridItem minWidth="250px">
                    <Container
                      px={10}
                      py={8}
                      borderRadius="10px"
                      boxShadow="base"
                      bg="white"
                      m={0}
                    >
                      <VStack
                        pb={3}
                        pt={1}
                        align="center"
                        onClick={() => {
                          navigate(Adminroutes.Courses);
                        }}
                      >
                        <Text color="#959595" fontSize="14px">
                          All courses
                        </Text>
                        <Text
                          color="#353535"
                          fontWeight="semibold"
                          fontSize={30}
                        >
                          {dashboard?.total_courses}
                        </Text>
                      </VStack>
                    </Container>
                  </GridItem>
                </Grid>
              </Box>
              <Box
                overflowX={"scroll"}
                className="scroll-hidden"
                width={"100%"}
                bg="white"
                boxShadow={"base"}
                borderRadius={"3px"}
              >
                <Box bg="transparent" px="20px" width={"100%"}>
                  <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    py="26px"
                  >
                    <Box color="#2B2B2B" fontWeight="800" fontSize="22px">
                      Trainees Onboarded
                    </Box>
                  </Flex>
                  <LineChart
                    width={1000}
                    height={300}
                    data={data}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="0 2" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="trainees" stroke="#EC3337" />
                  </LineChart>
                </Box>
              </Box>
            </Flex>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default AdminDashboard;
